import {Image, View, ViewStyle, Pressable, ImageStyle} from 'react-native';
import React, {useEffect, useState} from 'react';
import colors from 'theme/Colors';
import {spacing} from 'theme/Units';

type propType = Readonly<{
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}>;
export function Checkbox(props: propType) {
  const {checked, onChange} = props;

  const [selected, setSelected] = useState<boolean>(checked || false);
  useEffect(() => {
    setSelected(!!checked); // !! to ensure it has value and it is a boolean value,
    // if not that fallback to false as default value
  }, [checked]);

  function handleChange() {
    const newValue = !selected;
    setSelected(newValue);
    onChange?.(newValue);
  }

  return (
    <Pressable onPress={handleChange}>
      {!selected ? (
        <View style={[styles.checkbox, styles.checkboxUnselected]} />
      ) : (
        <View style={[styles.checkbox, styles.checkboxSelected]}>
          <Image
            source={require('assets/icons/tick_white@2x.png')}
            style={styles.icon}
            resizeMode="contain"
          />
        </View>
      )}
    </Pressable>
  );
}

type styleTypes = {
  checkbox: ViewStyle;
  checkboxSelected: ViewStyle;
  checkboxUnselected: ViewStyle;
  icon: ImageStyle;
};

const styles: styleTypes = {
  checkbox: {
    width: 20,
    height: 20,
    minHeight: 20,
    maxHeight: 20,
    padding: spacing[1],
    borderRadius: 4,
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderBlockColor: colors.palette.stroke,
  },
  checkboxSelected: {
    backgroundColor: colors.palette.brandBlue,
  },
  checkboxUnselected: {
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: colors.palette.nuetral4,
  },
  icon: {width: 12, height: 12, zIndex: 10},
};
